module.exports = __webpack_public_path__ + "static/media/icon-toux.80fd4239.svg";